// src/Dashboard/pages/user/Produits/components/ProductsToolbar.jsx

import React from "react";
import { FaSearch, FaShareAlt, FaTimes } from "react-icons/fa";

export default function ProductsToolbar({
  ui,
  debouncedQ,
  setDebouncedQ,
  onChange,
  onReset,
  onShare,
  shareCopied,
  resultCount = 0,
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_220px_auto] lg:items-end">
        <div>
          <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={debouncedQ}
              onChange={(event) => setDebouncedQ(event.target.value)}
              placeholder="Rechercher une application..."
              className="w-full rounded-2xl border border-slate-300 bg-white py-3 pl-10 pr-4 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
            Tri
          </label>

          <select
            value={ui.sort}
            onChange={(event) => onChange({ sort: event.target.value })}
            className="w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value="order">Ordre d’affichage</option>
            <option value="alpha">Nom A-Z</option>
          </select>
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={onShare}
            title={shareCopied ? "Lien copié !" : "Copier un lien partageable"}
            className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl text-sm font-bold ring-1 transition ${
              shareCopied
                ? "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:ring-emerald-800"
                : "bg-slate-50 text-slate-600 ring-slate-200 hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700 dark:hover:bg-slate-700"
            }`}
          >
            <FaShareAlt />
          </button>

          <button
            type="button"
            onClick={onReset}
            title="Réinitialiser"
            className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-50 text-slate-600 ring-1 ring-slate-200 transition hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700 dark:hover:bg-slate-700"
          >
            <FaTimes />
          </button>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <p className="font-medium text-slate-600 dark:text-slate-300">
          {resultCount} application{resultCount > 1 ? "s" : ""} affichée
          {resultCount > 1 ? "s" : ""}
        </p>

        {ui.q && (
          <span className="rounded-full bg-indigo-50 px-3 py-1 text-xs font-bold text-indigo-700 ring-1 ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20">
            Recherche : {ui.q}
          </span>
        )}
      </div>
    </div>
  );
}